export const MUI_license =
  '75f32c59d370efb2d34bb59f6766a34bTz0xMTY1NDEsRT0xNzg2NDA2Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y';
export const Syncfusion_license =
  'ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5VdENjXnpXdHFXRGFZ';
